/**
 * useCabinEnrolled — course_cabin_main_v1 kayıt kontrolü
 *
 * TanStack Query ile 5 dk cache.
 * Hem Navbar hem CabinEnrollmentGuard bu hook'u kullanır;
 * queryKey ['enrollments','cabin-access-check'] aynı olduğundan
 * sayfa geçişlerinde EK API çağrısı olmaz (cache hit).
 *
 * 404  → cabinEnrolled=false, cabinCheckError=false  (kesin kayıtsız)
 * 5xx  → cabinEnrolled=undefined, cabinCheckError=true (geçici hata)
 * Guard bu iki durumu AYRI işler: 404 → /dashboard; 5xx → erişime izin ver.
 *
 * @param {boolean} enabled  false ise query çalışmaz (admin/eğitmen için gereksiz)
 * @returns {{ cabinEnrolled: boolean|undefined, cabinCheckLoading: boolean, cabinCheckError: boolean }}
 */
import { useQuery } from '@tanstack/react-query';
import apiClient from '../../services/apiClient';

const CABIN_COURSE_ID = 'course_cabin_main_v1';

export const CABIN_QUERY_KEY = ['enrollments', 'cabin-access-check'];

export default function useCabinEnrolled(enabled) {
  const {
    data: cabinEnrolled,
    isLoading: cabinCheckLoading,
    isError: cabinCheckError,
  } = useQuery({
    queryKey: CABIN_QUERY_KEY,
    queryFn: async () => {
      try {
        await apiClient.get(`/enrollments/${CABIN_COURSE_ID}`);
        return true;
      } catch (err) {
        // 404 → kesin kayıtsız; hata değil, false döndür
        if (err.response?.status === 404) return false;
        // 5xx / timeout / ağ hatası → TanStack isError=true olsun
        throw err;
      }
    },
    enabled: !!enabled,
    staleTime: 5 * 60 * 1000,   // 5 dakika cache
    retry: 1,
    refetchOnWindowFocus: false,
  });

  return { cabinEnrolled, cabinCheckLoading, cabinCheckError };
}
